var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cm-select',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('name-with-icon',{attrs:{"value":item}})]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('name-with-icon',{attrs:{"value":item}})]}}])},'cm-select',_vm.options,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }